import React, { useState, useMemo } from 'react';
import { useSelector } from 'react-redux';
import WidgetSettings from '../../../components/dashboardcomponents/Settings/WidgetSettings';
import CompanyProfile from './CompanyProfile';
import PlanAndBillingCompany from './PlanAndBillingCompany';
import './style.css';
const CompanySettings = () => {
  // Removed admin check → everyone can see tabs
  const [activeTab, setActiveTab] = useState(0);

  // Memoized tab rendering
  const registrationUIRender = useMemo(() => {
    switch (activeTab) {
      case 0:
        return <CompanyProfile />;
      case 2:
        return <PlanAndBillingCompany />;
      case 4:
        return <WidgetSettings />;
      default:
        return null;
    }
  }, [activeTab]);

  const currentLanguage = useSelector(
    (state) => state.language.currentLanguage
  );

  const t = useSelector(
    (state) => state.language.translations[currentLanguage]
  );

  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
  };

  const isTabActive = (tabIndex) => activeTab === tabIndex;

  return (
    <div className="Settings-main-container">
      <div className="Settings-Container001">
        <p className="Ticket-text">{t.COMPANYSETTINGS}</p>
        <div className="Ticket-main-header">
          <div className="Ticket-text-section">
            <p
              className={`ticket-header-text ${isTabActive(0) ? 'TicketHeaderActive' : ''}`}
              onClick={() => handleTabClick(0)}
            >
              {t.COMPANYPROFILE}
            </p>



            <p
              className={`ticket-header-text ${isTabActive(2) ? 'TicketHeaderActive' : ''}`}
              onClick={() => handleTabClick(2)}
            >
              {t.COMPANYPLANANDBILLING}
            </p>
          </div>
        </div>
      </div>
      <div className="Settings-Main-Container">{registrationUIRender}</div>
    </div>
  );
};

export default CompanySettings;
